import React from 'react'
import { useQuery } from "@apollo/client"
import { get, sortBy } from 'lodash'

import AppFrame from '../AppFrame'
import { QUERY_APPOINTMENTS_DATA } from '../data/services/graphqlQueries'
import { map } from 'lodash'
import PageHeader from '../components/PageHeader'
import ClinicCard from '../components/ClinicCard'

export default ({globalData, clinic}) => {
  const { loading, error, data } = useQuery(QUERY_APPOINTMENTS_DATA, {
    notifyOnNetworkStatusChange: true
  })

  if (loading) return null

  const appointmentData = get(data,'pageData[0]')

  const cardCallback = (c) => {
    window.open(c.appointmentUrl, '_blank');
  }

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto px-4 pb-8 pt-12 min-h-[400px]">
        
        <PageHeader title={'Appointments'} />
          
        <div dangerouslySetInnerHTML={{__html: appointmentData ? appointmentData.body : ''}} className="mt-12 mb-8"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {
            map(globalData.clinics, (c, index) => {
              const _doctors = sortBy(data.doctors.filter((d) => {
                if (d.locations.includes(c.url)) {
                  return d
                }
              }), (d) => { return d.priority })

              if (!c.displayOnAppointmentsPage) return null

              return <ClinicCard 
                globalData={globalData} 
                clinic={c}
                key={`appointment-card-${index}`} 
                callback={cardCallback}
                cta="make an appointment"
                doctors={_doctors}
              />
            })
          }
        </div>
      </div>
    </AppFrame>
  )
}